import { api } from "@/lib/api-client";

export interface TransformPluginRow {
  id: string;
  pluginId: string;
  family: string;
  label: string;
  description: string;
  formSchema: unknown;
  defaultConfig: unknown;
  expression: string;
  hostCapabilities: string[];
  sampleSeeds: string[];
  status: "draft" | "published" | "archived";
  updatedAt: string;
}

export const transformPluginsApi = {
  list: () => api.get<{ plugins: TransformPluginRow[] }>("/transform-plugins"),
  // Published-only — used by the transform-chain step picker (F-043). Drafts/
  // archived plugins aren't resolvable at export time (getTenantOpDef only
  // matches status: 'published'), so the picker never offers them.
  listPublished: () =>
    api.get<{ plugins: TransformPluginRow[] }>("/transform-plugins?status=published"),
  get: (id: string) => api.get<TransformPluginRow>(`/transform-plugins/${id}`),
  create: (body: Partial<TransformPluginRow>) =>
    api.post<TransformPluginRow>("/transform-plugins", body),
  update: (id: string, body: Partial<TransformPluginRow>) =>
    api.put<TransformPluginRow>(`/transform-plugins/${id}`, body),
  publish: (id: string) =>
    api.post<TransformPluginRow>(`/transform-plugins/${id}/publish`),
  fork: (id: string) =>
    api.post<TransformPluginRow>(`/transform-plugins/${id}/fork`),
  remove: (id: string) => api.delete(`/transform-plugins/${id}`),
  testRun: (
    id: string,
    body: { input: string; fields: Record<string, string>; config: Record<string, unknown> },
  ) =>
    api.post<{
      output?: string;
      error?: string;
      trace: Array<{ step: number; op: string; input: unknown; output?: unknown; error?: string }>;
    }>(`/transform-plugins/${id}/test-run`, body),
};
